<svg
  class="compass"
  [class]="'compass--' + mode()"
  viewBox="0 0 100 108"
  aria-hidden="true">
  <path
    class="compass__hex"
    d="M50 6 L92 30 L92 78 L50 102 L8 78 L8 30 Z"
    fill="none"
    stroke-width="6"
    stroke-linejoin="round" />
  <circle class="compass__dot" cx="50" cy="20" r="2.4" />
  <circle class="compass__dot" cx="50" cy="88" r="2.4" />
  <circle class="compass__dot" cx="22" cy="54" r="2.4" />
  <circle class="compass__dot" cx="78" cy="54" r="2.4" />

  @if (mode() === 'clock') {
    <line
      class="compass__hand compass__hand--hour"
      x1="50"
      y1="54"
      x2="50"
      y2="34"
      stroke-width="5"
      stroke-linecap="round" />
    <line
      class="compass__hand compass__hand--minute"
      x1="50"
      y1="54"
      x2="66"
      y2="62"
      stroke-width="4"
      stroke-linecap="round" />
    <circle class="compass__axis" cx="50" cy="54" r="4.5" stroke-width="2.5" />
  } @else {
    <g class="compass__needle">
      <path class="compass__tip" d="M50 28 L58 54 L50 62 L42 54 Z" />
      <path class="compass__tail" d="M50 80 L42 54 L50 46 L58 54 Z" />
      <circle
        class="compass__axis"
        cx="50"
        cy="54"
        r="4.5"
        stroke-width="2.5" />
    </g>
  }
</svg>
